<template>
  <layout-pondlogs headerType="card" containerType="card" class="culture-yield">
    <template slot="title">{{ $t("Comn_yield") }}</template>
    <template slot="header">
      <el-row type="flex" justify="end" class="header-toolbar">
        <er-button
          size="mini"
          type="success"
          :disabled="isReadOnly"
          @click="
            handleClickAction($event, 'add', $lodash.cloneDeep(newHarvestLog))
          "
          >{{ $t("Harvest_load_a_harvest") }}</er-button
        >
        <er-input
          inputType="search"
          v-model="pondSearch"
          size="mini"
          class="input-search-pond"
          suffix-icon="el-icon-search"
          :placeholder="labelsAndPlaceHolder['search_pond'].placeholder"
        ></er-input>
        <el-col :span="5">
          <er-date-picker
            :clearable="true"
            type="daterange"
            class="date-picker-harvest"
            v-model="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            size="small"
            @change="handleDateChange"
          ></er-date-picker>
        </el-col>

        <er-column-selector
          key-to-store-defaults="yield-harvest-table"
          :title="`Column ${$t('Comn_visibility')}`"
          :columns="tableColumns"
          @change-selection="handleChangeInColumnSelection"
        ></er-column-selector>
      </el-row>
    </template>

    <el-row v-loading="loading" slot="pondlogs-default-layout-main">
      <er-data-tables
        :tableData="tableData"
        :columns="selectedColumns"
        :action-column="false"
        :key="$i18n.locale"
        :expand-column="true"
        type="white-header-table"
        unique-id="harvest-yield"
        :el-table-props="tableProps"
        :pagination-props="$constants.table['pagination-props']"
        :page-size="$constants.table['page-size']"
        @expand-change="handleExpandChange"
      >
        <!-- :expand-column="true" -->
        <!-- @expand-change="handleExpandChange" -->
        <template v-slot:expandColumn="{ row }">
          <er-data-tables
            v-loading="expandloading === row.data.pond_id._id"
            :tableData="getExpandedTableData(row.data)"
            :columns="expandedTableColumns"
            :el-table-props="tableProps"
            :action-column="false"
            unique-id="harvest-yield-inner-table"
            type="white-header-table-inner"
            layout="table"
          >
            <template v-slot:start_of_cultivation="{ row }">
              {{
                $moment(row.data.start_of_cultivation).format(
                  $commonUtils.MOMENT_DATE_FORMAT_WITH_YEAR
                )
              }}
            </template>

            <template v-slot:cultivation_cycle="{ row }">
              {{ row.data.cultivation_cycle }}
            </template>

            <template v-slot:doc="{ row }">{{ row.data.doc }}</template>
            <template v-slot:abw_header="{ header }">
              <span>{{ header.label }}</span>
              <span>({{ header.sub_label }})</span>
            </template>
            <template v-slot:biomass="{ row }">{{
              Math.round(row.data.biomass) | commas(getUserCountryCode)
            }}</template>
            <template v-slot:survival_percentage="{ row }">
              {{ row.data.survival_percentage | na("-") }}
            </template>

            <template v-slot:post_larva_stocked="{ row }">
              {{ row.data.post_larva_stocked | commas(getUserCountryCode) }}
            </template>

            <template v-slot:fcr="{ row }">
              {{ partialFCRFilter(row.data) }}
            </template>

            <template v-slot:actions="{ row }">
              <er-button
                type="text"
                :disabled="disabledEditAndDelete(row.data) || isReadOnly"
                size="mini"
                btnType="edit"
                :showLabel="true"
                :showIcon="true"
                @click="
                  handleClickAction($event, 'edit', $lodash.cloneDeep(row.data))
                "
              ></er-button>
              <el-divider direction="vertical"></el-divider>
              <er-button
                type="text"
                :disabled="disabledEditAndDelete(row.data) || isReadOnly"
                size="mini"
                btnType="delete"
                :showLabel="true"
                :showIcon="true"
                @click="handleRemoveResource($event, row.data)"
              ></er-button>
            </template>
          </er-data-tables>
        </template>
        <template v-slot:pond_name="{ row }">
          {{ row.data.pond_id.title }}
        </template>
        <template v-slot:start_of_cultivation="{ row }">
          {{ $moment(row.data.start_of_cultivation).format("DD MMM, YY") }}
        </template>

        <template v-slot:date="{ row }">
          {{ $moment(row.data.date).format("DD MMM, YY") }}
        </template>

        <template v-slot:doc="{ row }">{{ row.data.doc }}</template>

        <template v-slot:abw_header="{ header }">
          <span>{{ header.label }}</span>
          <span>({{ header.sub_label }})</span>
        </template>

        <template v-slot:post_larva_stocked="{ row }">
          {{ row.data.post_larva_stocked | commas(getUserCountryCode) }}
        </template>

        <template v-slot:fcr="{ row }">
          {{ partialFCRFilter(row.data) }}
        </template>
        <template v-slot:biomass="{ row }">{{
          Math.round(row.data.biomass) | commas(getUserCountryCode)
        }}</template>
        <template v-slot:survival_percentage="{ row }">
          {{ row.data.survival_percentage | na("-") }}
        </template>
        <template v-slot:actions="{ row }">
          <er-button
            type="text"
            :disabled="disabledEditAndDelete(row.data) || isReadOnly"
            size="mini"
            btnType="edit"
            :showLabel="true"
            :showIcon="true"
            @click="
              handleClickAction($event, 'edit', $lodash.cloneDeep(row.data))
            "
          ></er-button>
          <el-divider direction="vertical"></el-divider>
          <er-button
            type="text"
            :disabled="disabledEditAndDelete(row.data) || isReadOnly"
            size="mini"
            btnType="delete"
            :showLabel="true"
            :showIcon="true"
            @click="handleRemoveResource($event, row.data)"
          ></er-button>
        </template>
      </er-data-tables>
      <component
        :is="`harvestActionDialog`"
        :show-dialog="dialogVisible"
        :harvest-log="selectedHarvestLog"
        :action-to-perform="actionToPerform"
        @close_dialog="closeDialog"
      ></component>
    </el-row>
  </layout-pondlogs>
</template>

<script>
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import filtersMixin from "@/mixins/filtersMixin.js";
import harvestActionDialog from "@/components/culture/harvestActionDialog";
import { mapGetters } from "vuex";
import notificationMixin from "@/mixins/notificationMixin";
import { permissionsToStringMap as permissions } from "@/middleware/pageAccessManager";

export default {
  name: "HarvestYield",
  mixins: [errorHandlerMixin, filtersMixin, notificationMixin],
  components: {
    harvestActionDialog
  },
  data: function() {
    return {
      date: [],
      dialogVisible: false,
      selectedHarvestLog: "",
      actionToPerform: "",
      pondSearch: "",
      harvestLogs: [],
      harvestYear: "",
      loading: false,
      tableProps: {
        size: "small",
        rowKey: this.getRowKey,
        defaultSort: {
          prop: "date",
          order: "descending"
        }
      },
      permissionsData: {
        name: "harvestYield",
        keyToValidateAccess: "PERMISSIONS",
        PERMISSIONS: [permissions.MANAGE_HARVEST]
      },
      // filters: [
      //   {
      //     value: "",
      //     filterFn: (row, filter) => {
      //       return row.pond_name
      //         .toLowerCase()
      //         .includes(filter.value.toLowerCase());
      //     }
      //   }
      // ],
      pondIdToHarvestData: {},
      expandloading: "",
      selectedColumns: {}
    };
  },
  computed: {
    ...mapGetters("user", {
      isReadOnly: "isReadOnly",
      getUserCountryCode: "getUserCountryCode",
      getUserTimeZoneOffset: "getUserTimeZoneOffset"
    }),
    disabledEditAndDelete() {
      return harvestRecord => {
        // console.log(harvestRecord);
        return (
          this.$moment(harvestRecord.created_at).diff(
            this.$moment().utc(),
            "days"
          ) >= 7
        );
      };
    },
    newHarvestLog() {
      // console.log(this.$moment().format("YYYY-MM-DD HH:mm:ss"));
      return {
        abw: 0,
        biomass: 0,
        date: new Date(),
        fcr: 0,
        pond_name: "",
        pond_id: "",
        post_larva_stocked: "",
        start_of_cultivation: "",
        survival_percentage: 0,
        cumulative_feed: "MANUAL_AND_POND_MOTHER",
        biomass_units: "KG",
        type: "PARTIAL"
      };
    },

    tableData() {
      return this.harvestLogs.filter(
        log =>
          !this.pondSearch ||
          (log || { pond_id: { title: "No Data" } }).pond_id.title
            .toLowerCase()
            .includes(this.pondSearch.toLowerCase())
      );
    },
    getMapPondIdPond() {
      return this.$store.getters["pond/getMapPondidPond"];
    },
    labelsAndPlaceHolder() {
      return {
        date_picker: {
          placeholder: this.$t("Comn_hrvst_date")
        },
        search_pond: { placeholder: this.$t("Comn_search") }
      };
    },
    currLocation() {
      return this.$store.getters["user/getCurrUserLocation"];
    },
    currLocationId() {
      return this.currLocation._id;
    },
    tableColumns() {
      return {
        pond_name: {
          label: this.$t("Comn_pond_name"),
          prop: "pond_name",
          sortable: true,
          sortMethod: (a, b) =>
            this.$commonUtils.alphaNumericComparator(
              a.pond_id.title,
              b.pond_id.title
            ),
          minWidth: 120,
          default: true
        },
        start_of_cultivation: {
          label: this.$t("Comn_soc"),
          prop: "start_of_cultivation",
          sortable: true,
          minWidth: 80,
          default: true
        },
        date: {
          label: this.$t("Comn_hoc"),
          prop: "date",
          sortable: true,
          minWidth: 100,
          default: true
        },
        doc: {
          label: this.$t("Comn_doc"),
          prop: "doc",
          sortable: true,
          minWidth: 80,
          default: true
        },
        post_larva_stocked: {
          label: this.$t("Pond_pls_stocked"),
          prop: "post_larva_stocked",
          sortable: true,
          width: 120,
          default: false
        },
        abw: {
          label: this.$t("ABW_abw"),
          sub_label: "g",
          prop: "abw",
          sortable: true,
          minWidth: 100,
          default: true
        },
        fcr: {
          label: this.$t("Comn_fcr"),
          prop: "fcr",
          sortable: true,
          minWidth: 90,
          default: true
        },
        biomass: {
          label: this.$t("PM_bio_mass_kg"),
          prop: "biomass",
          sortable: true,
          minWidth: 100,
          default: true
        },
        survival_percentage: {
          label: this.$t("Comn_survival_percentage"),
          prop: "survival_percentage",
          sortable: true,
          minWidth: 120,
          default: true
        },
        type: {
          label: this.$t("Comn_harvest"),
          prop: "type",
          sortable: true,
          minWidth: 100,
          default: true
        },
        actions: {
          label: this.$t("Comn_actions"),
          default: false,
          minWidth: 130
        }
      };
    },
    expandedTableColumns() {
      return {
        start_of_cultivation: {
          label: this.$t("Comn_soc"),
          prop: "start_of_cultivation",
          sortable: true,
          minWidth: 80
        },
        doc: {
          label: this.$t("Comn_doc"),
          prop: "doc",
          sortable: true,
          minWidth: 70
        },
        cultivation_cycle: {
          label: this.$t("Comn_cycle"),
          prop: "cultivation_cycle",
          sortable: true,
          minWidth: 70
        },
        post_larva_stocked: {
          label: this.$t("Pond_pls_stocked"),
          prop: "post_larva_stocked",
          sortable: true,
          minWidth: 110
        },
        abw: {
          label: this.$t("ABW_abw"),
          sub_label: "g",
          prop: "abw",
          minWidth: 70,
          sortable: true
        },
        fcr: {
          label: this.$t("Comn_fcr"),
          prop: "fcr",
          sortable: true,
          minWidth: 60
        },
        biomass: {
          label: this.$t("PM_bio_mass_kg"),
          prop: "biomass",
          minWidth: 100,
          sortable: true
        },
        survival_percentage: {
          label: this.$t("Comn_survival_percentage"),
          prop: "survival_percentage",
          minWidth: 120,
          sortable: true
        },
        type: {
          label: this.$t("Comn_harvest"),
          prop: "type",
          sortable: true,
          minWidth: 80
        },
        actions: { label: this.$t("Comn_actions"), minWidth: 120 }
      };
    },
    getExpandedTableData() {
      return harvestLog => {
        const pondObj = harvestLog.pond_id;
        if (pondObj) {
          console.log(this.pondIdToHarvestData[pondObj._id]);
          // get culture with in the year

          const filteredHarvest = this.pondIdToHarvestData[pondObj._id]
            ? this.pondIdToHarvestData[pondObj._id].filter(
                ({ start_of_cultivation }) =>
                  new Date(start_of_cultivation) >=
                  new Date(new Date().getFullYear(), 0, 1)
              )
            : [];
          // const { start_of_cultivation } = this.pondIdToHarvestData[
          //   pondObj._id
          // ];

          // return this.pondIdToHarvestData[pondObj._id];
          return filteredHarvest;
        }
        return [];
      };
    },
    pickerOptions() {
      const arrYears = [this.$moment().year()].reduce((acc, curr) => {
        for (let i = 0; i < 10; i++) {
          acc.push(curr - i);
        }
        return acc;
      }, []);
      return {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            no: 1,
            unit: "days",
            text: this.$t("Comn_yesterday"),
            type: "date"
          },
          { no: 6, unit: "days", text: this.$t("last_7days"), type: "date" },
          { no: 14, unit: "days", text: this.$t("last_15days"), type: "date" },
          { no: 1, unit: "months", text: this.$t("last_30days"), type: "date" },
          {
            no: 3,
            unit: "months",
            text: this.$t("last_3months"),
            type: "date"
          },
          {
            no: 6,
            unit: "months",
            text: this.$t("last_6months"),
            type: "date"
          },
          ...arrYears.map((x, index) => ({
            no: index,
            unit: "year",
            text: "" + x,
            type: "date"
          }))
        ].map(shortCut => {
          return {
            text: shortCut.text,
            onClick: picker => {
              console.log(picker);
              if (shortCut.unit === "year") {
                const end = this.$moment();
                const start = this.$moment();
                start.subtract(shortCut.no, shortCut.unit).startOf("year");
                end.subtract(shortCut.no, shortCut.unit).endOf("year");
                picker.$emit("pick", [start.toDate(), end.toDate()]);
              } else {
                const end = this.$moment();
                const start = this.$moment();
                start.subtract(shortCut.no, shortCut.unit);
                picker.$emit("pick", [start.toDate(), end.toDate()]);
              }
            }
          };
        })
      };
    }
  },
  mounted() {
    this.harvestYear = "" + this.$moment().year();
    this.initComponent();
  },
  methods: {
    getRowKey(row) {
      return row._id;
    },
    async closeDialog(event) {
      this.dialogVisible = false;
      // console.log(this.selectedHarvestLog);
      if (event !== "close") {
        this.initComponent();
        this.pondIdToHarvestData = {};
        await this.handleExpandChange(this.selectedHarvestLog);
      }
    },
    async initComponent() {
      this.loading = true;
      const from_date = this.getYearDate("" + this.$moment().year(), "start");
      // const to_date = this.getYearDate("" + this.$moment().year(), "end");
      //  this.$moment()
      //     .utc()
      //     .toISOString();
      const to_date = this.$moment()
        .utcOffset(this.getUserTimeZoneOffset)
        .toISOString();
      this.date = [from_date, to_date];
      try {
        await this.$store.dispatch("pond/fetchAllPonds", {
          location_id: this.currLocation._id,
          status: ["ACTIVE"],
          get_all: true
        });
        const harvestLogs = await this.$store.dispatch(
          "pond/fetchAllHarvestLogs",
          {
            get_all: true,
            recent_record: true,
            location_id: this.currLocation._id,
            from_date,
            to_date
          }
        );
        this.harvestLogs = this.$lodash.cloneDeep(harvestLogs);
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    async handleDateChange(updatedDateRange) {
      if (updatedDateRange != null && updatedDateRange.length > 0) {
        this.loading = true;
        try {
          const harvestLogs = await this.$store.dispatch(
            "pond/fetchAllHarvestLogs",
            {
              from_date: updatedDateRange[0] + "T00:00:00.000Z",
              to_date: updatedDateRange[1] + "T23:59:59.999Z"
            }
          );
          this.harvestLogs = harvestLogs;
        } catch (err) {
          this.errorMessages(err, true);
        } finally {
          this.loading = false;
        }
      } else {
        this.initComponent();
      }
    },
    async handleExpandChange(row) {
      this.expandloading = row.pond_id._id;
      try {
        if (this.pondIdToHarvestData[row.pond_id._id]) return;
        const expandTableData = await this.$store.dispatch(
          "pond/fetchAllHarvestLogs",
          {
            get_all: true,
            pond_id: row.pond_id._id,
            location_id: this.currLocation._id
          }
        );
        this.$set(this.pondIdToHarvestData, row.pond_id._id, expandTableData);
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.expandloading = "";
      }
    },
    handleClickAction(event, actionToPerform, harvestObj) {
      try {
        this.isEditable(this.permissionsData);

        this.dialogVisible = true;
        this.actionToPerform = actionToPerform;
        this.selectedHarvestLog = harvestObj;
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    async handleRemoveResource(event, harvestLog) {
      try {
        this.canUserDelete(this.permissionsData);
        await this.deleteConfirmation(
          `${this.$t("Comn_harvest")} ${this.$t("details")}`,
          harvestLog.pond_name
        );

        this.loading = true;
        await this.$store.dispatch("pond/deleteHarvestLog", harvestLog._id);
        this.notifySuccess({
          msgLangkey: {
            title: "Comn_delete_success_msg",
            count: 0,
            child: {
              item: this.$t("Comn_yield"),
              source: harvestLog.pond_name
            }
          }
        });
        await this.initComponent();
        this.pondIdToHarvestData = {};
        await this.handleExpandChange(harvestLog);
      } catch (err) {
        // if (err !== "cancel") {
        //   this.errorMessages(err, true);
        // }
        const errors = [];
        if (err.response) {
          errors.push({ message: err.response.data.message });
          this.errorFailToSave(errors);
        } else {
          this.errorMessages(err, true);
        }
      } finally {
        this.loading = false;
        // this.loadPondsList();
      }
    },
    async error400Handler(err) {
      const errorCodeToTranslation = {
        HARVEST_DETAILS_ADDED_MORE_THAN_7_DAYS: this.$t(
          "final_harvest_cannot_delete"
        )
      };
      await this.errorFailToSave([
        {
          message:
            errorCodeToTranslation[err.response.data.error_code] ||
            this.$t("Something_went_wrong_try_again")
        }
      ]);
    },
    handleChangeInColumnSelection(selectedColumns) {
      const latestColumn = selectedColumns[selectedColumns.length - 1];
      if (selectedColumns.includes("actions") && latestColumn !== "actions") {
        selectedColumns.pop();
        selectedColumns.pop();
        selectedColumns.push(latestColumn);
        selectedColumns.push("actions");
      }

      const columnObj = selectedColumns.reduce((acc, curr) => {
        acc[curr] = this.tableColumns[curr];
        return acc;
      }, {});
      this.selectedColumns = Object.assign({}, columnObj);
      console.log(this.selectedColumns);
    },
    getYearDate(year, type) {
      if (year === this.$moment().year() && type === "end") {
        return this.$moment()
          .utc()
          .toISOString();
      } else if (type === "start") {
        return this.$moment()
          .year(year)
          .utc()
          .startOf("year")
          .toISOString();
      } else if (type === "end") {
        return this.$moment()
          .year(year)
          .utc()
          .endOf("year")
          .toISOString();
      }
    },
    async handleChangeInYear(selectedYear) {
      console.log(selectedYear);
      const from_date = this.getYearDate(selectedYear, "start");
      const to_date = this.getYearDate(selectedYear, "end");
      this.$set(this.pondIdToHarvestData, {});
      try {
        const harvestLogs = await this.$store.dispatch(
          "pond/fetchAllHarvestLogs",
          {
            get_all: true,
            recent_record: true,
            location_id: this.currLocation._id,
            from_date,
            to_date
          }
        );
        this.harvestLogs = harvestLogs;
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    partialFCRFilter(data) {
      console.log(data.fcr, data.type, data);
      if (data.type === "PARTIAL" && !data.fcr) {
        return "-";
      } else {
        return data.fcr.toFixed(2);
      }
    }
  }
};
</script>

<style lang="scss">
.culture-yield {
  .header-toolbar {
    & > *:not(:last-child) {
      margin-right: 10px;
    }

    .er-button {
      height: 28px !important;
    }

    .er-column-selector .btn-column-selector {
      display: flex;
      align-items: center;
    }
  }

  .date-picker-harvest {
    width: 9rem;
  }
  .input-search-pond {
    width: 9rem;
  }
  &.culture-yield-scroll {
    height: 100%;
  }
  .culture-yield-scroll-view {
    padding-right: 10px;
  }
  .culture-yield-scroll-wrap {
    height: 100%;
    overflow-x: auto;
  }
  .table--primary {
    .el-table {
      border-radius: 10px;
      box-shadow: 0px 1px 6px #00000029;
      .cell {
        text-align: center;
        font-size: 13px;
        .el-tag {
          font-size: 13px;
        }
      }
      th.is-leaf {
        border-bottom: unset;
      }
      .el-table__header {
        background-color: #44a1ff;
        tr {
          background-color: transparent;
          color: white;
        }
        th {
          background-color: transparent;
          border-bottom: unset;
          &:nth-last-child(2) {
            .cell {
              border-right: none;
            }
          }
          & > .cell {
            display: inline-block;
            -webkit-box-sizing: border-box;
            border-right: 1px solid white;
            box-sizing: border-box;
            position: relative;
            vertical-align: middle;
            padding-left: 10px;
            padding-right: 10px;
            width: 100%;
            height: 32px;
            line-height: 32px;
          }
          // .sort-caret {
          //   &.ascending {
          //     border-bottom-color: transparent;
          //   }
          //   &.descending {
          //     border-top-color: transparent;
          //   }
          // }
        }
      }
    }
  }

  .is-sortable {
    &.ascending .sort-caret.ascending {
      border-bottom-color: #ffffff;
    }
    &.descending .sort-caret.descending {
      border-top-color: #ffffff;
    }
  }
  .el-pagination {
    margin-top: 15px;
    vertical-align: middle;
    .el-pagination__sizes {
      .el-input--mini {
        .el-input__icon {
          line-height: 22px;
        }
        .el-input__inner {
          height: 22px;
          line-height: 22px;
        }
      }
    }
  }

  .el-range-editor.el-input__inner {
    padding: 3px 7px !important;
  }

  .el-range-editor--mini .el-range-separator {
    width: 5% !important;
  }
}
</style>
